import { cloneDeep } from 'lodash'
// 埋点事件名称
const ANALYZE_EVENT = {
  WEB_SEARCH: 'Web_Search',
  WEB_DEALER_DETAILS: 'Web_Dealer_Details',
  WEB_SHARE: 'Web_Share',
  WEB_DOWNLOAD: 'Web_Download',
  WEB_DOWNLOAD_TYPE: 'Web_Download_Type'
}

const EVENT_DETAIL = {
  [ANALYZE_EVENT.WEB_SEARCH]: {
    name: '搜索',
    property: {
      location: {
        p_name: '搜索位子',
        type: 'STRING',
        values: ['首页', '交易商详情页', '新闻详情页']
      },
      type: {
        p_name: '搜索类型',
        type: 'STRING',
        values: ['智能搜索列表', '搜索联想', '搜索']
      },
      content: {
        p_name: '搜索内容',
        type: 'STRING'
      },
      userid: {
        p_name: '用户id',
        type: 'STRING'
      }
    }
  },
  [ANALYZE_EVENT.WEB_DEALER_DETAILS]: {
    name: '交易商详情页',
    property: {
      content: {
        p_name: '交易商名称',
        type: 'STRING'
      },
      code: {
        p_name: '交易商code',
        type: 'STRING'
      },
      userid: {
        p_name: '用户id',
        type: 'STRING'
      }
    }
  },
  [ANALYZE_EVENT.WEB_SHARE]: {
    name: '分享',
    property: {
      location: {
        p_name: '分享位子',
        type: 'STRING',
        values: ['交易商详情页', '新闻详情页']
      },
      type: {
        p_name: '分享类型',
        type: 'STRING',
        values: ['facebook', 'twitter', 'wechat']
      },
      code: {
        p_name: '分享详情页code',
        type: 'STRING',
        des: '交易商code || 新闻code'
      },
      content: {
        p_name: '分享页面名称',
        type: 'STRING',
        des: '交易商取交易商英文名称 || 新闻用标'
      },
      userid: {
        p_name: '用户id',
        type: 'STRING'
      }
    }
  },
  [ANALYZE_EVENT.WEB_DOWNLOAD]: {
    name: '下载页',
    property: {
      location: {
        p_name: '下载位子',
        type: 'STRING',
        values: ['首页', '交易商详情页', '新闻详情页']
      },
      userid: {
        p_name: '用户id',
        type: 'STRING'
      }
    }
  },
  [ANALYZE_EVENT.WEB_DOWNLOAD_TYPE]: {
    name: '下载页类型',
    property: {
      type: {
        p_name: '下载类型',
        type: 'STRING',
        value: ['外汇天眼（全球', '外汇天眼APK']
      },
      userid: {
        p_name: '用户id',
        type: 'STRING'
      }
    }
  }
}

const getAnalyzeContentByEventName = (eventName) => {
  return cloneDeep(EVENT_DETAIL[eventName])
}

export {
  ANALYZE_EVENT,
  EVENT_DETAIL,
  getAnalyzeContentByEventName
}
